const KEY = 'heidi.onboarding.demoBooked';

export const getHasBookedDemo = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const markDemoBooked = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY, '1');
  } catch {
    // localStorage unavailable (private mode, quota) — silently noop; resolver
    // simply won't fall back to webinar this session, which is acceptable.
  }
};

export const clearDemoBookedFlag = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // noop
  }
};
